import { Func1 } from "redux";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { nullSelector } from "../reduxUtils";
import { IState } from "../../state/IState";
import { isObjectPropsEquals } from "../fpUtilsEx";

export interface IOptionalSelector<TIn, TOut> {
    (...names: string[]): Func1<TIn, TOut>;
}

export const useOptionalSelectorMemo = <TIn, TOut>(
    builder: IOptionalSelector<TIn, TOut>,
    emptySelector = nullSelector<TOut>()
) => (...names: string[]) =>
    useMemo(
        () =>
            names.length > 0 && names.every(x => x)
                ? builder(...names)
                : emptySelector,
        names
    );

export function useOptionalSelector<TIn, TOut>(
    builder: IOptionalSelector<TIn, TOut>,
    ...names: string[]
): TOut {
    const selector = useOptionalSelectorMemo(builder)(...names);
    return useSelector(selector);
}

export const useObjectSelector = <T>(selector: Func1<IState, T>): T =>
    useSelector(selector, isObjectPropsEquals);
